export default "__VITE_ASSET__5153b79b__"